import type { ResponsiveDialogDescriptionProps } from '@/shared/components/ui/custom/responsive-dialog';
import { ResponsiveDialogDescription } from '@/shared/components/ui/custom/responsive-dialog';
import { cn } from '@/shared/utils/cn';

export function DownloadModalDescription(
  props: ResponsiveDialogDescriptionProps,
) {
  const { className, ...rest } = props;
  return (
    <ResponsiveDialogDescription
      className={cn('leading-5', className)}
      {...rest}
    />
  );
}
